<template>
<ValidationObserver tag="div" ref="form" v-slot="{ invalid, handleSubmit }">
    <CElementCover :opacity="0.8" style="z-index:1" v-show="showLoading" />
    <CForm method="post" @submit.prevent="handleSubmit(submit)">
        <span class="badge badge-danger p-2 w-100 mb-2">{{ errMessage }}</span>

        <CRow>
            <CCustomInput
                sm="12"
                vid="slug"
                :name="$t('role.slug')"
                rules="required"
                required
                v-model="role.slug"
                ltr
                description="تنها از حروف انگلیسی استفاده نمایید"
                placeholder="مثال: admin"
            />

            <CCustomInput
                col="12" sm="6"
                vid="name"
                :name="$t('role.name')"
                rules="required"
                required
                v-model="role.name"
                placeholder="مثال: ادمین"
            />

            <CCustomInput
                col="12" sm="6"
                vid="plural_name"
                :name="$t('role.plural_name')"
                rules="required"
                required
                v-model="role.plural_name"
                placeholder="مثال: ادمین‌ها"
            />
            <CCustomInputCheckbox
                sm="12"
                vid="is_admin"
                :name="$t('role.is_admin')"
                v-model="role.is_admin"
            />
        </CRow>

        <CButton :disabled="invalid" type="submit"  color="primary" class="mt-3 px-4">{{ $t('submit') }}</CButton>
    </CForm>
</ValidationObserver>
</template>

<script>
import { CCustomInputCheckbox } from '@/components/form'

export default {
    name: 'Form',

    components: {
        CCustomInputCheckbox
    },

    props: {
        submit: {
            default: function() {},
            required: true,
        },
        role: {
            default: function() {
                return {
                    name: '',
                    plural_name: '',
                    slug: '',
                    is_admin: false,
                }
            },
        },
    },

    data() {
        return {
            errMessage: '',
            showLoading: false,
        }
    },
}
</script>